import { render } from "./editar.vue?vue&type=template&id=64d980be&scoped=true"
import script from "./editar.vue?vue&type=script&lang=js"
export * from "./editar.vue?vue&type=script&lang=js"

import "./editar.vue?vue&type=style&index=0&id=64d980be&scoped=true&lang=scss"

import exportComponent from "/var/www/amee/gdaudit-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d980be"]])

export default __exports__